import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";
var LearningMapNothingComponent = (function () {
    function LearningMapNothingComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.text = "";
    }
    LearningMapNothingComponent.prototype.ngOnInit = function () {
    };
    LearningMapNothingComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    return LearningMapNothingComponent;
}());
export { LearningMapNothingComponent };



// WEBPACK FOOTER //
// ./src/app/learning-map-nothing.component.ts.pre-build-optimizer.js